import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// The design system defines numeric font-size utilities (text-9, text-12, …) as
// theme tokens. tailwind-merge doesn't know these are font sizes, so it treats
// e.g. `text-12` as conflicting with `text-muted-foreground` and drops it. Teach
// it that any `text-<number>` belongs to the font-size group.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [(value: string) => /^\d+$/.test(value)] }],
    },
  },
});

export const cn = (...classNames: ClassValue[]) => {
  return twMerge(clsx(classNames));
};
